import angular from 'angular';

angular
  .module('myConsultApp')
  .service(
    'UserService',
    function (
      $cookieStore,
      $localStorage,
      $location,
      $resource,
      $rootScope,
      $window,
      AuthService,
      ATLAS_API,
      ENV,
      redirectToUrlAfterLogin,
      Session,
    ) {
      this.accessToken = Session.accessToken ? Session.accessToken : null;
      this.refreshToken = Session.refreshToken ? Session.refreshToken : null;
      this.expiresIn = Session.expiresIn ? Session.expiresIn : null;

      this.currentUser = $localStorage.currentUser ? $localStorage.currentUser : null;
      this.isAdminUser = $localStorage.isAdminUser ? $localStorage.isAdminUser : false;
      this.isSuperUser = $localStorage.isSuperUser ? $localStorage.isSuperUser : false;
      this.vetOrganizations = $localStorage.vetOrganizations
        ? $localStorage.vetOrganizations
        : false;
      this.currentOrganization = $localStorage.currentOrganization
        ? $localStorage.currentOrganization
        : false;
      this.subscriptions = {
        isPWRSubscribed: $localStorage.isPWRSubscribed ? $localStorage.isPWRSubscribed : false,
        isRewardsSubscribed: $localStorage.isRewardsSubscribed
          ? $localStorage.isRewardsSubscribed
          : false,
        isTiggerSubscribed: $localStorage.isTiggerSubscribed
          ? $localStorage.isTiggerSubscribed
          : false,
        isSolensiaSubscribed: $localStorage.isSolensiaSubscribed
          ? $localStorage.isSolensiaSubscribed
          : false,
        isLibrelaSubscribed: $localStorage.isLibrelaSubscribed
          ? $localStorage.isLibrelaSubscribed
          : false,
      };
      this.baseUser = $localStorage.baseUser ? $localStorage.baseUser : null;
      this.baseUserId = $localStorage.baseUserId ? $localStorage.baseUserId : null;

      this.checkAdminAuth = async () => {
        this.isAdminUser = false;
        $localStorage.isAdminUser = false;
        $rootScope.isAdminUser = false;
        this.isSuperUser = false;
        $localStorage.isSuperUser = null;
        $rootScope.isSuperUser = false;
        this.currentUser = await this.checkUser();
        if (this.currentUser) {
          await this.setCurrentUser(this.currentUser);
          await this.checkAndSetAdminAndSuperuser();
          if (!this.isAdminUser && !this.isSuperUser) {
            await this.getOrganizations().then(async (response) => {
              await this.setVetOrganizations(response);
            });
          }
        } else {
          await this.unsetOptions();
        }
        return [
          this.currentUser,
          this.isAdminUser,
          this.isSuperUser,
          this.vetOrganizations,
          this.currentOrganization,
          this.subscriptions,
          this.baseUser,
        ];
      };

      this.unsetOptions = () => {
        this.currentUser = null;
        this.isAdminUser = false;
        this.isSuperUser = false;
        this.currentOrganization = null;
        this.vetOrganizations = null;
        this.subscriptions = {
          isPWRSubscribed: false,
          isRewardsSubscribed: false,
          isTiggerSubscribed: false,
          isSolensiaSubscribed: false,
          isLibrelaSubscribed: false,
        };
        this.baseUser = null;
        this.baseUserId = null;

        $localStorage.currentUser = null;
        $localStorage.isAdminUser = false;
        $localStorage.isSuperUser = null;
        $localStorage.currentOrganization = null;
        $localStorage.vetOrganizations = null;
        $localStorage.subscriptions = {
          isPWRSubscribed: false,
          isRewardsSubscribed: false,
          isTiggerSubscribed: false,
          isSolensiaSubscribed: false,
          isLibrelaSubscribed: false,
        };
        $localStorage.isPWRSubscribed = false;
        $localStorage.isRewardsSubscribed = false;
        $localStorage.isTiggerSubscribed = false;
        $localStorage.baseUser = null;
        $localStorage.baseUserId = null;

        $rootScope.currentUser = null;
        $rootScope.isAdminUser = false;
        $rootScope.isSuperUser = false;
        $rootScope.currentOrganization = null;
        $rootScope.vetOrganizations = null;
        $rootScope.subscriptions = {
          isPWRSubscribed: false,
          isRewardsSubscribed: false,
          isTiggerSubscribed: false,
          isSolensiaSubscribed: false,
          isLibrelaSubscribed: false,
        };
        $rootScope.isPWRSubscribed = false;
        $rootScope.isRewardsSubscribed = false;
        $rootScope.isTiggerSubscribed = false;
        $rootScope.isSolensiaSubscribed = false;
        $rootScope.isLibrelaSubscribed = false;
        $rootScope.baseUser = null;
        $rootScope.baseUserId = null;
        localStorage.clear();
      };

      this.checkAndGrabUserInfo = async () => {
        if (!this.currentUser) {
          this.currentUser = await this.checkUser();
        }
        if (this.currentUser) {
          await this.setCurrentUser(this.currentUser);
          await this.checkAndSetAdminAndSuperuser();
          if (!this.isAdminUser && !this.isSuperUser) {
            await this.checkVetOrganizations();
          }
          await this.redirectUser();
          $rootScope.addSuperUserConfig();
          return [
            this.currentUser,
            this.isAdminUser,
            this.isSuperUser,
            this.vetOrganizations,
            this.currentOrganization,
            this.subscriptions,
            this.baseUser,
          ];
        }
      };

      this.checkUser = function () {
        var user = $resource(
          ENV.apiEndpoint + '/1.0/me/',
          {},
          {
            get: {
              headers: {
                Authorization: 'Bearer ' + Session.accessToken,
              },
            },
          },
        );

        return user.get().$promise.then(function (response) {
          return response.data;
        });
      };

      this.getCurrentUser = async () => {
        if ($localStorage.currentUser || this.currentUser) {
          var user = this.currentUser ? this.currentUser : $localStorage.currentUser;
          await this.setCurrentUser($localStorage.currentUser);
        }
        return $localStorage.currentUser;
      };

      this.setCurrentUser = async (user) => {
        $rootScope.currentUser = user;
        $localStorage.currentUser = user;
        this.currentUser = user;
        await Session.create(user.id, user.email);
      };

      this.checkAndSetAdminAndSuperuser = async () => {
        var groups = this.currentUser.groups;
        for (var i = 0; i < groups.length; i++) {
          if (groups[i] === 'zoetis_administrators') {
            this.isAdminUser = true;
            $localStorage.isAdminUser = true;
            $rootScope.isAdminUser = true;
          }
          if (groups[i] === 'zoetis_superusers') {
            this.isSuperUser = true;
            $localStorage.isSuperUser = true;
            $rootScope.isSuperUser = true;
          }
        }
        if (this.isAdminUser || this.isSuperUser) {
          await Session.create(this.currentUser.id, this.currentUser.email);
        } else {
          $localStorage.isAdminUser = false;
          $rootScope.isAdminUser = false;
          $localStorage.isSuperUser = false;
          $rootScope.isSuperUser = false;
        }
      };

      this.checkVetOrganizations = async () => {
        if ($localStorage.vetOrganizations || this.vetOrganizations) {
          var organizations = this.vetOrganizations
            ? this.vetOrganizations
            : $localStorage.vetOrganizations;
          await this.handleVetOrganizations(organizations);
        } else {
          await this.getOrganizations().then(async (response) => {
            await this.handleVetOrganizations(response);
          });
        }
      };

      this.getOrganizations = function () {
        var organization = $resource(
          ENV.apiEndpoint + '/1.0/organizations/',
          {},
          {
            get: {
              headers: {
                Authorization: 'Bearer ' + Session.accessToken,
              },
            },
          },
        );

        return organization.get().$promise.then(function (response) {
          return response.organizations;
        });
      };

      this.handleVetOrganizations = async (organizations) => {
        if (!organizations) {
          $('#login-form').html(
            "<div class='text-center'>Sorry, you can't login, there are no organizations associated to this account</div>",
          );
          return;
        }

        await this.setVetOrganizations(organizations);
      };

      this.setVetOrganizations = async (organizations) => {
        await Session.create(this.currentUser.id, this.currentUser.email);
        var noDefault = true;
        var cookieOrg = $localStorage.currentOrg;

        angular.forEach(organizations, async (organization, index) => {
          if (organization.id == cookieOrg && noDefault) {
            await this.setCurrentOrganization(organization);
            noDefault = false;
          } else if (organization.is_default && noDefault) {
            await this.setCurrentOrganization(organization);
            noDefault = false;
          }
        });
        if (noDefault) {
          await this.setCurrentOrganization(organizations[0]);
        }
        this.vetOrganizations = organizations;
        $rootScope.vetOrganizations = organizations;
        $localStorage.vetOrganizations = organizations;
      };

      this.setCurrentOrganization = async (org) => {
        this.currentOrganization = org;
        $rootScope.currentOrganization = org;
        $localStorage.currentOrganization = org;
        await this.setSubscriptions();
      };

      // Set Subscription for Paw Path Organization User
      this.setSubscriptions = function () {
        if (this.currentOrganization) {
          const application = this.currentOrganization.applications;
          $localStorage.subscriptions = {
            isPWRSubscribed: false,
            isRewardsSubscribed: false,
            isTiggerSubscribed: false,
            isSolensiaSubscribed: false,
            isLibrelaSubscribed: false,
          };

          this.isPWRSubscribed = false;
          this.isRewardsSubscribed = false;
          this.isTiggerSubscribed = false;
          this.isSolensiaSubscribed = false;
          this.isLibrelaSubscribed = false;

          for (var i = 0; i < application.length; i++) {
            if (application[i].name === 'PWR' && application[i].is_active === true) {
              this.subscriptions.isPWRSubscribed = true;
              $localStorage.subscriptions.isPWRSubscribed = true;
            }
            if (application[i].name === 'LOYALTY' && application[i].is_active === true) {
              this.subscriptions.isRewardsSubscribed = true;
              $localStorage.subscriptions.isRewardsSubscribed = true;
            }
            if (application[i].name === 'TIGGER' && application[i].is_active === true) {
              this.subscriptions.isTiggerSubscribed = true;
              $localStorage.subscriptions.isTiggerSubscribed = true;
            }
            if (application[i].name === 'SOLENSIA' && application[i].is_active === true) {
              this.subscriptions.isSolensiaSubscribed = true;
              $localStorage.subscriptions.isSolensiaSubscribed = true;
            }
            if (application[i].name === 'LIBRELA-IEP' && application[i].is_active === true) {
              this.subscriptions.isLibrelaSubscribed = true;
              $localStorage.subscriptions.isLibrelaSubscribed = true;
            }
          }
        } else {
          this.isPWRSubscribed = false;
          this.isRewardsSubscribed = false;
          this.isTiggerSubscribed = false;
          this.isSolensiaSubscribed = false;
          this.isLibrelaSubscribed = false;
          this.subscriptions = {
            isPWRSubscribed: false,
            isRewardsSubscribed: false,
            isTiggerSubscribed: false,
            isSolensiaSubscribed: false,
            isLibrelaSubscribed: false,
          };
          $localStorage.subscriptions = this.subscriptions;
        }
      };

      this.redirectUser = () => {
        // if (redirectToUrlAfterLogin.url !== '/' && redirectToUrlAfterLogin.url !== '/login') {
        //   if ($location.$$path !== redirectToUrlAfterLogin.url) {
        //     $location.path(redirectToUrlAfterLogin.url);
        //   }
        // } else {
        //   if (!this.isAdminUser) {
        //     if (this.subscriptions.isTiggerSubscribed && this.subscriptions.isRewardsSubscribed) {
        //       if ($location.$$path != '/') {
        //         $location.path('/');
        //       }
        //     } else if (this.subscriptions.isTiggerSubscribed) {
        //       if ($location.$$path != '/catpainiq') {
        //         $location.path('/catpainiq');
        //       }
        //     } else {
        //       if ($location.$$path != '/rewards') {
        //         $location.path('/rewards');
        //       }
        //     }
        //   } else {
        //     if ($location.$$path != '/admin') {
        //       $location.path('/admin');
        //     }
        //   }
        // }

        if (redirectToUrlAfterLogin.url !== '/') {
          $window.location.href = redirectToUrlAfterLogin.url;
          return;
        }

        if (this.isAdminUser) {
          $window.location.href = '/admin';
          return;
        }

        if (this.subscriptions.isRewardsSubscribed) {
          $window.location.href = '/rewards';
          return;
        }

        if (this.subscriptions.isTiggerSubscribed) {
          $window.location.href = '/catpainiq';
        }

        if (this.subscriptions.isSolensiaSubscribed) {
          $window.location.href = '/experience-solensia';
        }

        if (this.subscriptions.isLibrelaSolensiaSubscribed) {
          $window.location.href = '/experience-librela';
        }
      };

      this.isValid = function () {
        var valid = false;
        Session.loadTokens();
        if (
          Session.accessToken &&
          Session.refreshToken &&
          Session.expiresIn &&
          this.currentUser &&
          (this.isAdminUser || this.isSuperUser || this.currentOrganization)
        ) {
          valid = true;
        } else if (Session.refreshToken) {
          let credentials = {
            client_id: ATLAS_API.clientId,
            grant_type: 'refresh_token',
            refresh_token: Session.refreshToken,
          };
          AuthService.refreshToken(credentials).then(function (response) {
            Session.setTokens(response.access_token, response.refresh_token, response.expires_in);
            this.checkAndGrabUserInfo().then(function (response) {
              valid = true;
            });
          });
        } else {
          $cookieStore.remove('csrftoken');
          $cookieStore.remove('sessionid');
          Session.destroy();
          $localStorage.currentUser = null;
          $localStorage.isAdminUser = null;
          $localStorage.isSuperUser = null;
          $rootScope.currentUser = null;
          $rootScope.isAdminUser = false;
          $rootScope.isSuperUser = false;
          this.unsetOptions();
        }
        return valid;
      };

      this.checkSuperUser = function () {
        var valid = false;

        if (
          Session.baseAccessToken &&
          Session.baseRefreshToken &&
          Session.baseExpiresIn &&
          Session.baseUserId
        ) {
          valid = true;
        }
        return valid;
      };
    },
  );
